import { useCallback } from 'react';
import { prop } from 'ramda';
import { log } from 'log';
import { useLiveGamesSelector } from 'js/store/hooks';

import { SUBSCRIPTIONS_STORE } from '../constants';

export const useLiveGamesUnsubscribe = () => {
    const socket = useLiveGamesSelector(prop('socket'));
    const isSocketConnected = useLiveGamesSelector(prop('isSocketConnected'));

    return useCallback((
        { correlationIds, subscriptionIds = [] }: { correlationIds: string[]; subscriptionIds?: string[] }
    ): void => {
        if (socket && isSocketConnected) {
            let requestSubscriptionIds = subscriptionIds;

            if (correlationIds.length) {
                requestSubscriptionIds = SUBSCRIPTIONS_STORE.subscriptions
                    .filter(subscription => correlationIds.includes(subscription.correlationId))
                    .map(subscription => subscription.subscriptionId);
            }

            const request = {
                unsubscribeRequest: {
                    subscriptionIds: requestSubscriptionIds
                }
            };

            if (!request.unsubscribeRequest.subscriptionIds.length) {
                return;
            }

            log('log', '[LIVE | Portal] sending unsubscribeRequest', request);

            socket.send(request);
        }
    }, [isSocketConnected, socket]);
};
